"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EcomFilterView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const react_1 = require("react");
const __1 = require("../..");
const FilterSort_1 = require("../../lib/common/FilterSort");
const SEARCH_PATH = 'ecommerce.search';
const SectionsWrap = (0, app_1.styled)(ui_1.Stack) `
  @media ${app_1.mobile} {
    display: none;
  }
`;
function FilterSectionTitle({ filter, menuLink: LinkComp = FilterSort_1.Title, }) {
    const _a = (0, __1.useSearchMeta)().params, { category } = _a, paramsWithoutCategory = __rest(_a, ["category"]);
    const searchPath = (0, app_1.useContextPath)(SEARCH_PATH);
    const href = filter.path === '/' ? searchPath : `${searchPath}/${filter.path}`;
    return ((0, jsx_runtime_1.jsx)(LinkComp, Object.assign({ href: new app_1.Href(href, paramsWithoutCategory), shallow: true, css: (0, app_1.css) `
        text-transform: uppercase;
        ${FilterSort_1.titleStyles}
      ` }, { children: filter.title })));
}
function FilterSection({ filter, menuLink: LinkComp = app_1.Link, loading, }) {
    var _a;
    const { category, params } = (0, __1.useSearchMeta)();
    const searchPath = (0, app_1.useContextPath)(SEARCH_PATH);
    return ((0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical", spacing: "0.1rem" }, { children: [(0, jsx_runtime_1.jsx)(FilterSectionTitle, { menuLink: LinkComp, filter: filter }), (0, jsx_runtime_1.jsx)(FilterSort_1.Ul, { children: loading ? ((0, jsx_runtime_1.jsx)(ui_1.Skeleton, { rows: 1 })) : ((_a = filter.values) === null || _a === void 0 ? void 0 : _a.map(({ title, value }) => ((0, jsx_runtime_1.jsx)(FilterSort_1.Li, Object.assign({ "$active": category === value }, { children: (0, jsx_runtime_1.jsx)(LinkComp, Object.assign({ shallow: true, href: new app_1.Href(`${searchPath}/[category]`, params) }, { children: title })) }), value)))) })] })));
}
function Input({ filterDefinitions, setValue, }) {
    const { category } = (0, __1.useSearchMeta)();
    (0, react_1.useEffect)(() => {
        setValue('filter', category !== null && category !== void 0 ? category : '/');
    }, [category, setValue]);
    const flatFilters = (0, react_1.useMemo)(() => filterDefinitions.reduce((acc, filter) => {
        const { values, path, title } = filter;
        const parent = { value: path, title };
        return [...acc, parent, ...(values !== null && values !== void 0 ? values : [])];
    }, []), [filterDefinitions]);
    return ((0, jsx_runtime_1.jsx)(ui_1.SelectInput, Object.assign({ name: "filter", label: "Filtruj", defaultValue: category }, { children: flatFilters === null || flatFilters === void 0 ? void 0 : flatFilters.map((value) => ((0, jsx_runtime_1.jsx)(ui_1.SelectInput.Option, Object.assign({ value: value.value }, { children: value.title }), value.value))) })));
}
function EcomFilterView({ filterDefinitions, menuLink, spacing = 'small', loading, className, }) {
    return ((0, jsx_runtime_1.jsxs)(FilterSort_1.Wrap, Object.assign({ className: className }, { children: [(0, jsx_runtime_1.jsx)(SectionsWrap, Object.assign({ kind: "vertical", spacing: spacing }, { children: filterDefinitions.map((filter) => ((0, jsx_runtime_1.jsx)(FilterSection, { menuLink: menuLink, filter: filter, loading: loading }, filter.title))) })), (0, jsx_runtime_1.jsx)(FilterSort_1.Selector, { children: (0, jsx_runtime_1.jsx)(ui_1.Form, { children: (0, jsx_runtime_1.jsx)(ui_1.FormContext, { children: ({ setValue }) => ((0, jsx_runtime_1.jsx)(Input, { filterDefinitions: filterDefinitions, setValue: setValue })) }) }) })] })));
}
exports.EcomFilterView = EcomFilterView;
